// Toggle a member's access to one org workspace (the assignment dialog on
// the Organization Members tab): POST to grant, DELETE to revoke, then
// refresh the members overview so the per-member workspace lists update.
import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/workspaceAssign';
import { fetchRequest as fetchMembers } from '../../actions/organizations/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, workspaceId, userId, role, assign } = action.payload;
  try {
    if (assign) {
      yield call(
        axios.post,
        `${config.API_URL}/workspace/${workspaceId}/members`,
        { user_id: userId, role },
        { headers: getLocalUser() },
      );
    } else {
      yield call(
        axios.delete,
        `${config.API_URL}/workspace/${workspaceId}/members/${userId}`,
        { headers: getLocalUser() },
      );
    }
    yield put(fetchSuccess({ workspaceId, userId, assign }));
    yield put(fetchMembers({ orgId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not update workspace access';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  // takeEvery: toggles on different rows may be dispatched in parallel.
  yield takeEvery(REQUEST, operation);
}
